(ns web3.meta.asset
  (:require [web3.structured-data :as d]
            [clojure.string :as str]
            [applied-science.js-interop :as j]
            [web3.utils :as utils]
            [clojure.set :as set]))

(defn current-url []
  ;; NOTE
  ;; product-SD and content-SD currently *assume* that they are
  ;; 'about' the main item of the current page. If they are ever
  ;; used in other contexts, they will need their 'refers-to' property
  ;;

  (-> js/location (.toString) (.replace (.-search js/location) "")))

(defn model-name [model]
  (let [{:keys [tags
                number
                manufacturer
                contents]} model]
    (str/join " " [(:name manufacturer)
                   number
                   (some-> (first tags) :name)])))

(defn model-title [model]
  (str/join ["Help with your " (model-name model)]))

(defn model-description [{:as model
                          :keys [products]}]
  (str (model-title model)
       " manuals, replacement parts, accessories and more."
       (when (seq products)
         (str "("
              (str/join ", " (map (comp str/trim :name) products))
              ")"))))

(defn model-SD [model {:keys [sd/canonical-url]}]
  ;; TODO
  ;; description
  ;; global identifier
  [d/JSONLD
   [d/Product (merge {:name (model-name model)
                      :brand {"@type" "Thing"
                              :name (-> model :manufacturer :name)}
                      :sku (:id model)
                      :image (-> model :primaryImage :link)}
                     (when canonical-url
                       {:mainEntityOfPage canonical-url}))]])

(defn product-SD [{:as product
                   :keys [thumbnailImage primaryImage]}
                  {:keys [sd/accessory-or-part-for-url]}]
  ;; TODO
  ;; brand
  ;; global identifier
  [d/JSONLD
   [d/Product (merge {:name (:name product)
                      :sku (:id product)
                      :description (:description product)
                      :image (:link (or thumbnailImage primaryImage))}
                     (when accessory-or-part-for-url
                       {:isAccessoryOrSparePartFor {:url accessory-or-part-for-url}}))]])

(defn content-SD [{:as content :keys [category]} {:keys [sd/about-url]}]
  (case category
    ("document"
      "note")
    [d/JSONLD
     [d/generic {:type "document"
                 :jsonldtype "DigitalDocument"
                 :schema (merge {:name (:title content)}
                                (when about-url
                                  {:about {:url about-url}})
                                (if (= category "note")
                                  {:text (utils/link-data-decode (:link content))}
                                  (-> content
                                      (select-keys [:description :imageLink])
                                      (set/rename-keys {:imageLink :image}))))}]]
    "video"
    [d/JSONLD
     [d/generic {:type "video"
                 :jsonldtype "VideoObject"
                 :schema {:name (:title content)
                          :description (:description content)
                          :thumbnailUrl (:imageLink content)
                          :uploadDate (:createdAt content)
                          :contentUrl (:link content)
                          :about {:url about-url}}}]]
    nil))
